import { IStoreState } from '../types';

export const getWatermarksList = (state: IStoreState) => state.watermarks;
export const getWatermarksProcessed = (state: IStoreState) => state.watermarksProcess;
